import { AnyAction } from 'redux'
import { createAction } from 'redux-actions'
import { ThunkDispatch } from 'redux-thunk'
import { RootState } from '../../reducers'
import { post, url } from '../../../javascripts/http'
import { AccountType, isHasBasicInfo } from '../../../javascripts/generic'
import { actionLogoutSuccess } from '../user'
import { message } from 'antd'
import { StoreService } from '../../../api/sennotech/scanner/v2/store'
import { LicenseService } from '../../../api/sennotech/scanner/v2/license'
import { AccountService } from '../../../api/sennotech/scanner/v2/account'

const storeService = new StoreService(url, post);
const accountService = new AccountService(url, post);
const licenseService = new LicenseService(url, post);


export function actionCreateStore (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        try {

            let orgId = getState().user.orgId;
            let res =  await storeService.createStore({
                institutionId: +orgId,
                name: data.name
            })

            if(data.accountType === AccountType.MOBILENUMBER) {
                await accountService.createAccount({
                    organizationId: res.id,
                    role: "superAdmin",
                    countryCode: "86",
                    mobileNumber: data.accountName,
                } as any)
            }
            else if(data.accountType === AccountType.EMAIL){
                await accountService.createAccount({
                    organizationId: res.id,
                    role: "superAdmin",
                    email: data.accountName,
                } as any)
            }

            let operationList = getState().silizhuStore.operationList || [];
            if(!operationList.length) {
                let res_operation = await licenseService.listOperations({})
                operationList = res_operation.operations
            }
            let operation = operationList.find((item) => {
                return item.name == "ORGANIZATION"
            }) || {};

            await licenseService.issueLicense({
                organizationId: res.id,
                expireTime:  {
                    seconds: data.endTime,
                    nanos: 0, 
                },
                operation: operation
            } as any)

            dispatch(actionCreateStoreSuccess({}));
            
            dispatch(actionGetStoreList({
                pageNum: 1,
                pageSize: 10
            }));
            
        } catch (error: any) {
            if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionOperateStoreFail({
                    data: '管理员账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'organization already existed.') {
                dispatch(actionOperateStoreFail({
                    data: '商户名称已存在'
                }))
            }
            else {
                dispatch(actionOperateStoreFail({
                    data: '创建失败'
                }))
            }
        }
    }
}

export const ACTION_CREATESTORE_SUCCESS = 'SILIZHU.ACTION_CREATESTORE_SUCCESS'

export interface ActionCreateStorePayload {
    
}

export const actionCreateStoreSuccess = createAction(
    ACTION_CREATESTORE_SUCCESS,
    (payload: ActionCreateStorePayload) => {
        return payload;
    }
)

// 操作失败提示 商户统一用
export const ACTION_OPERATESTORE_FAIL = 'SILIZHU.ACTION_OPERATESTORE_FAIL'

export interface ActionOperateStoreFailPayload {
    data: string
}

export const actionOperateStoreFail = createAction(
    ACTION_OPERATESTORE_FAIL,
    (payload: ActionOperateStoreFailPayload) => {
        return payload;
    }
)

export function actionGetStoreList (data) {
    return async(dispatch: ThunkDispatch<RootState, any, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        message.loading('数据加载中...', 0)
        try {

            let orgId = getState().user.orgId;

            let operationList = getState().silizhuStore.operationList || [];
            if(!operationList.length) {
                let res_operation = await licenseService.listOperations({})
                operationList = res_operation.operations
            }

            let operation = operationList.find((item) => {
                return item.name == "ORGANIZATION"
            }) || {};
            
            let res = await storeService.listStores({
                institutionId: +orgId,
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize
            });

            if(+res.totalElements === 0) {
                message.destroy();
                dispatch(actionGetStoreListSuccess({
                    storeList: {},
                    operationList: operationList,
                }))
                return;
            }

            let organizationIds = res.stores.map((item) => {
                return item.id
            });
            let res_account = await accountService.batchGetAccounts({
                organizationIds: organizationIds
            })

            let res_operation = await licenseService.batchGetLicenses({
                operation: operation,
                organizationIds: organizationIds
            } as any);

            res.stores = res.stores.map((item) => {
                let account = res_account.accountInfos.find((a) => {
                    return a.organizationId === item.id
                }) || { account: {} }
                let operation = res_operation.licenseInfos.find((o) => {
                    return o.organizationId === item.id
                }) || { license: {} }
                return {
                    ...item,
                    account: account.account,
                    license: operation.license
                }
            })

            dispatch(actionGetStoreListSuccess({
                storeList: res,
                operationList: operationList,
            }))
           
        } catch (error) {
            console.log(error)
        }
        dispatch(actionOperateStoreFail({
            data: ''
        }))
        message.destroy();
    }
}

export const ACTION_GETSTORELIST_SUCCESS = 'SILIZHU.ACTION_GETSTORELIST_SUCCESS'

export interface ActionGetStoreListPayload {
    storeList: any
    operationList: any
}

export const actionGetStoreListSuccess = createAction(
    ACTION_GETSTORELIST_SUCCESS,
    (payload: ActionGetStoreListPayload) => {
        return payload;
    }
)

export function actionUpdateStore (data, formdata, page) {
    return async(dispatch: ThunkDispatch<RootState, any, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        
        try {

            await storeService.updateStore({
                storeId: data.id,
                name: formdata.name,
                description: data.description,
                logo: data.logo
            });

            if(formdata.accountType === AccountType.MOBILENUMBER) {
                await accountService.updateAccount({
                    organizationId: data.id,
                    accountId: data.account.id,
                    role: "superAdmin",
                    name: data.account.name==''?formdata.name:data.account.name,
                    countryCode: "86",
                    mobileNumber: formdata.accountName,
                })
            }
            else if(formdata.accountType === AccountType.EMAIL) {
                await accountService.updateAccount({
                    organizationId: data.id,
                    accountId: data.account.id,
                    role: "superAdmin",
                    name:  data.account.name==''?formdata.name:data.account.name,
                    email: formdata.accountName,
                })
            }
           

            await licenseService.updateLicense({
                organizationId: data.id,
                operation: data.license.operation,
                expireTime:  {
                    seconds: formdata.endTime,
                    nanos: 0, 
                },
            })
            dispatch(actionUpdateStoreSuccess({
                data: {}
            }))

            message.success('更新成功', 12);

            dispatch(actionGetStoreList(page));

        } catch (error: any) {

            if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionOperateStoreFail({
                    data: '管理员账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'organization already existed.') {
                dispatch(actionOperateStoreFail({
                    data: '商户名称已存在'
                }))
            }
            else {
                dispatch(actionOperateStoreFail({
                    data: '更新失败'
                }))
            }
            console.log(error)
        }
    }
}

export const ACTION_UPDATESTORE_SUCCESS = 'SILIZHU.ACTION_UPDATESTORE_SUCCESS'

export interface ActionUpdateStorePayload {
    data: any
}

export const actionUpdateStoreSuccess = createAction(
    ACTION_UPDATESTORE_SUCCESS,
    (payload: ActionUpdateStorePayload) => {
        return payload;
    }
)

export function actionDeleteStore (id, page) {
    return async(dispatch: ThunkDispatch<RootState, any, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        
        message.loading("删除中...", 0);

        try {

            await storeService.deleteStore({
                id: id,
            });
            dispatch(actionDeleteStoreSuccess({
                data: {}
            }))

            message.destroy();
            dispatch(actionGetStoreList(page));

        } catch (error: any) {
            message.destroy();
            message.error(error.response.headers['senno-exception-message'] || "删除失败", 6)
            console.log(error)
        }
    }
}

export const ACTION_DELETESTORE_SUCCESS = 'SILIZHU.ACTION_DELETESTORE_SUCCESS'

export interface ActionDeleteStorePayload {
    data: any
}

export const actionDeleteStoreSuccess = createAction(
    ACTION_DELETESTORE_SUCCESS,
    (payload: ActionDeleteStorePayload) => {
        return payload;
    }
)
